import React from 'react';
import Logo from '../../Common/Logo';

const LeftSide = () => {
  return (
    <div className="bg-[#F4F2EF]  flex     max-991:hidden flex-col pt-8 ">
      {/* Logo at the top */}
      <div className=" pl-8">
        <Logo />
      </div>

      {/* Orange card with text overlay */}
      <div className="relative  w-[90%] h-full overflow-hidden pt-8">
        {/* Main illustration image */}
        <div className="flex justify-center">
          <img
            src="/agency/assets/onboarding-img.png"
            alt="workfall onboarding img"
            className="w-full h-full"
          />
        </div>
      </div>
    </div>
  );
};

export default LeftSide;
